
import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/equipmentLedger',
    meta: { title: '设备台账' },
    component: Layout,
    redirect: '/equipmentLedger/list',
    children: [
      {
        path: 'list',
        meta: { title: '设备台账', activeMenu: '/equipmentLedger' },
        component: () => import('@/views/equipmentLedger/EquipmentLedger.vue')
      },
      {
        path: 'detail',
        meta: { title: '设备台账详情', activeMenu: '/equipmentLedger' },
        component: () => import('@/views/equipmentLedger/EquipmentLedgerDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑设备台账', activeMenu: '/equipmentLedger' },
        component: () => import('@/views/equipmentLedger/EquipmentLedgerAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增设备台账', activeMenu: '/equipmentLedger' },
        component: () => import('@/views/equipmentLedger/EquipmentLedgerAdd.vue')
      }

    ]
  }

]
